<template>
  <q-footer reveal elevated>
    <div class="toast" v-if="duplicates.length">
      <ul class="duplicates-list">
        <li class="duplicates-list__item duplicates__item--description">
          <p>{{ $t("duplicates.general") }}</p>
        </li>
        <li
          class="duplicates-list__item"
          v-for="duplicate in duplicates"
          :key="duplicate.id"
        >
          <span class="duplicates-list__item-title text-bold">{{
            duplicate.title
          }}</span>
          <span class="q-pl-md">
            {{ duplicate.duplicates }} / {{ duplicate.all }}
          </span>
        </li>
      </ul>
      <div class="row">
        <q-space />
        <q-btn
          color="primary"
          :loading="loading"
          :disable="loading"
          :label="$t('common.understand')"
          class="q-my-md q-ml-auto"
          @click="acceptDuplicate"
        />
      </div>
    </div>
  </q-footer>
</template>

<script>
import api from "@/api/api";
import { mapActions, mapState } from "vuex";

export default {
  name: "BaseFooter",
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      eventsList: (state) => state.global.eventsList,
      referralEventsList: (state) => state.global.referralEventsList,
    }),
  },
  data() {
    return {
      duplicates: [],
      loading: false
    };
  },
  methods: {
    ...mapActions({
      getEvents: "global/getEvents",
      getReferralEvents: "global/getReferralEvents",
    }),
    getEventName(id) {
      const event = this.eventsList.find((item) => item.id === id);
      return event?.post_title ?? this.$t("duplicates.unknownEvent");
    },
    async fetchDuplicateImages() {
      try {
        if (!this.user) {
          return;
        }

        const {
          data: { data: duplicateImages },
        } = await api.getDuplicates(this.user.id);
        if (duplicateImages.length === 0) {
          return console.log("No duplicate images");
        }

        this.duplicates = duplicateImages.map(
          ({ all, duplicates, eventId }) => {
            return {
              all,
              duplicates,
              title: this.getEventName(eventId),
            };
          }
        );
      } catch (err) {
        console.error("Error fetching duplicate images:", err);
      }
    },
    async acceptDuplicate() {
      this.loading = true;
      try {
        const response = await api.acceptDuplicates(this.user.id);
        if (response.status === 200) {
          this.duplicates = [];

          this.$q.notify({
            icon: "done",
            color: "positive",
            message: this.$t("duplicates.acceptSuccess"),
          });
        }
      } catch (err) {
        this.$q.notify({
          icon: "error",
          color: "negative",
          message: this.$t("duplicates.acceptError") || err.message,
        });
      } finally {
        this.loading = false;
      }
    },
  },
  async mounted() {
    if (this.user && (!this.eventsList || this.eventsList.length === 0)) {
      await this.getEvents();
    }

    if (!this.referralEventsList || this.referralEventsList.length === 0) {
      await this.getReferralEvents();
    }

    await this.fetchDuplicateImages();
  },
};
</script>
<style>
.toast {
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  max-width: 30rem;
  padding: 1.25rem;
  background-color: #000;
}
.duplicates-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

@media (max-width: 450px) {
  .toast {
    bottom: 0;
    right: 0;
    left: 0;
    max-width: 100%;
    border-radius: 0;
  }
}
</style>
